import { useRef, useState } from 'react'
import './App.css'

// @ts-ignore
import { Inking2DSample } from './ink/Inking2d'
// @ts-ignore
import { InputListener } from 'digital-ink';
// @ts-ignore
import factory from "@wacom/license-manager"

function App() {

  const [ready, setReady] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  return (
    <>
      <div>
        <form onSubmit={async (e) => {
          const form = e.target as HTMLFormElement;
          const licenseInput = form.elements.namedItem('license') as HTMLInputElement;
          const licenseKey = licenseInput.value;
          console.log('setting license', licenseKey);

          e.preventDefault();

          try{
            const licenseManager = await factory();
            await licenseManager.setLicense(licenseKey);
            console.log('license set', licenseManager);
          } catch (e) {
            console.error('Failed to set license', e);
            alert('Failed to set license: ' + e);
            return;
          }
          setReady(true);
        }}>
          <label htmlFor="license">license:</label>
          <input type="text" id="license" name="license" />
          <button type="submit">Submit</button>
        </form>
      </div>
      <div>
        {ready ? <p>Ready to draw!</p> : <p>Please enter a license key.</p>}
        { ready && <canvas ref={(ref)=> {
          if (!ref) return;
          canvasRef.current = ref;

          if (InputListener.canvas) {

          } else {
            
            try {
              const s = new Inking2DSample(ref);
              InputListener.attach(s);
            } catch (e) {
              console.error('Failed to attach input listener', e);
              alert('Failed to attach input listener: ' + e);
            }
          }
        }} id="canvas" width="800" height="600"></canvas>}
      </div>
    </>
  )
}

export default App
